import { createContext, useContext, useState } from 'react'
import { useLocation } from 'react-router-dom'

import { paths } from 'src/config/paths'

export type ProfessionalHeaderContextType = {
  theme: 'light' | 'dark'
  setTheme: (theme: 'light' | 'dark') => void
}

export const ProfessionalHeaderContext = createContext<ProfessionalHeaderContextType>({
  theme: 'dark',
  setTheme: () => {},
})

export const useProfessionalHeaderContext = () => {
  const context = useContext(ProfessionalHeaderContext)
  if (!context) {
    throw new Error('useProfessionalHeaderContext must be used within a ProfessionalHeaderProvider')
  }
  return context
}

export const ProfessionalHeaderProvider = ({ children }: { children: React.ReactNode }) => {
  const [theme, setTheme] = useState<'light' | 'dark'>('dark')
  const location = useLocation()

  const isProfessionalHomePage = location.pathname === paths.professionals.index.getHref()

  // Only use the white transparent theme if we are on the professional home page.
  const themeOverride = isProfessionalHomePage ? theme : 'dark'

  return (
    <ProfessionalHeaderContext.Provider value={{ theme: themeOverride, setTheme }}>
      {children}
    </ProfessionalHeaderContext.Provider>
  )
}
